import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../controls/Modal';
import LabeledInput from '../../controls/LabeledInput';

// Универсальная модалка с одним полем «название» (подкатегории, паки).
export default function SimpleNameModal({ kicker, title, label, initial, placeholder, onSave, onDelete, onClose }) {
    const [name, setName] = useState(initial || '');
    return (
        <Modal
            open
            kicker={kicker}
            title={title}
            size="sm"
            onClose={onClose}
            footer={(
                <>
                    {onDelete && <button type="button" className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={onDelete}>Удалить</button>}
                    <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
                    <button type="button" className="btn btn-primary" onClick={() => onSave(name.trim())} disabled={!name.trim()}>Сохранить</button>
                </>
            )}
        >
            <LabeledInput label={label} value={name} onChange={(e) => setName(e.target.value)} placeholder={placeholder} />
        </Modal>
    );
}

SimpleNameModal.propTypes = {
    kicker: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    initial: PropTypes.string,
    placeholder: PropTypes.string,
    onSave: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    onClose: PropTypes.func.isRequired
};

SimpleNameModal.defaultProps = { initial: '', placeholder: undefined, onDelete: null };
